export const FETCH_AGENTS_ACTIVE = 'fetchAgentsActive';
export const FETCH_AGENTS_ACTIVE_SUCCESS = 'fetchAgentsActiveSuccess';
export const FETCH_AGENTS_INVITED = 'fetchAgentsInvited';
export const FETCH_AGENTS_INVITED_SUCCESS = 'fetchAgentsInvitedSuccess';
export const FETCH_AGENTS_INACTIVE = 'fetchAgentsInactive';
export const FETCH_AGENTS_INACTIVE_SUCCESS = 'fetchAgentsInactiveSuccess';
export const FETCH_AGENTS_ERROR = 'fetchAgentsError';
export const FETCH_AGENTS_LOADING = 'fetchAgentsLoading';
export const FETCH_AGENT_DETAILS = 'fetchAgentDetails';
export const SET_AGENT_DETAILS = 'setAgentDetails';
export const UPDATE_AGENT = 'updateAgent';
export const UPDATE_AGENT_SUCCESS = 'updateAgentSuccess';
export const FETCH_CLIENTS = 'fetchClients';
export const SET_CLIENTS = 'setClients';
export const FETCH_CLIENTS_ACTION_REQUIRED = 'fetchClientsActionRequired';
export const SET_CLIENTS_ACTION_REQUIRED = 'setClientsActionRequired';
export const EXPORT_CLIENTS = 'exportClients';
export const EXPORT_CLIENTS_ACTION_REQUIRED = 'exportClientsActionRequired';
export const FETCH_CLIENT_DETAILS = 'fetchClientDetails';
export const SET_CLIENT_DETAILS = 'setClientDetails';
export const PRINT_CLIENT_FILES = 'printClientFiles';
export const DOWNLOAD_CLIENT_FILES = 'downloadClientFiles';
export const INVITE_AGENT = 'inviteAgent';
export const INVITE_AGENT_SUCCESS = 'inviteAgentSuccess';
export const CANCEL_INVITE = 'cancelInvite';
export const CANCEL_INVITE_SUCCESS = 'cancelInviteSuccess';
export const ASSIGN_COACH = 'assignCoach';
export const ASSIGN_NEGOTIATOR = 'assignNegotiator';
export const FETCH_ALL_AGENTS_ACTIVE = 'fetchAllAgentsActive';
export const FETCH_ALL_AGENTS_ACTIVE_SUCCESS = 'fetchAllAgentsActiveSuccess';
export const SET_ROUTE_TO_REDIRECT = 'setRouteToRedirect';
export const ARCHIVE_CLIENT = 'archiveClient';
export const RESEND_INVITATION = 'resendInvitation';
export const RESEND_INVITATION_SUCCESS = 'resendInvitationSuccess';
export const ADD_CLIENT = 'addClient';
